import { type Connector } from 'types/swagger';

type Priority = 'vehicle' | 'connector' | 'default';

const getSocByConnector = (connector: Connector, priority: Priority) => {
  const transaction = connector.latest_transaction;
  const vehicle = transaction ? transaction.vehicle : undefined;

  switch (priority) {
    case 'vehicle':
      if (vehicle?.latest_soc) return parseFloat(vehicle.latest_soc);
      if (transaction?.soc_stop) return transaction.soc_stop;
      return undefined;
    case 'connector':
      if (transaction?.soc_stop) return transaction.soc_stop;
      if (vehicle?.latest_soc) return parseFloat(vehicle.latest_soc);
      return undefined;
    default:
      if (transaction?.soc_stop) return transaction.soc_stop;
      if (vehicle?.latest_soc) return parseFloat(vehicle.latest_soc);
      return undefined;
  }
};

export default getSocByConnector;
